import { createContext, useContext } from "react";
import type { User } from "@domain/Auth";
import type { CompanyContextValue } from "./CompanyContext.types";
import { useCompanyContextViewModel } from "./CompanyContext.vm";

const CompanyContext = createContext<CompanyContextValue>({
	companies: [],
	selectedCompany: null,
	setSelectedCompany: () => {},
	isLoading: false,
	isInitialized: false,
});

interface CompanyContextProviderProps {
	user: User | undefined;
	children: React.ReactNode;
}

export function CompanyContextProvider({ user, children }: CompanyContextProviderProps) {
	const value = useCompanyContextViewModel(user);
	return <CompanyContext.Provider value={value}>{children}</CompanyContext.Provider>;
}

export function useCompanyContext(): CompanyContextValue {
	return useContext(CompanyContext);
}

export { CompanyContext };
